__turbopack_context__.v({
  "btn": "BackButton-module__sMpUVW__btn",
  "container": "BackButton-module__sMpUVW__container",
  "fadeInItems": "BackButton-module__sMpUVW__fadeInItems",
  "spacing--lg": "BackButton-module__sMpUVW__spacing--lg",
  "spacing--md": "BackButton-module__sMpUVW__spacing--md",
  "spacing--sm": "BackButton-module__sMpUVW__spacing--sm",
  "spacing--xl": "BackButton-module__sMpUVW__spacing--xl",
  "spacing--xs": "BackButton-module__sMpUVW__spacing--xs",
  "spacing--xxl": "BackButton-module__sMpUVW__spacing--xxl",
  "spacing--xxs": "BackButton-module__sMpUVW__spacing--xxs",
  "spacing--xxxl": "BackButton-module__sMpUVW__spacing--xxxl",
  "spacing--xxxs": "BackButton-module__sMpUVW__spacing--xxxs",
});
